
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ele_records",
      function () {
        return require("private-next-pages/ele_records.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ele_records"])
      });
    }
  